import React from "react";
import { t } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import FullWidthPageBackground from "components/FullWidthPageBackground";
import "./style.scss";

export default function BlockBookACoach() {
  return (
    <div className="block-book-a-coach text-center">
      <FullWidthPageBackground className="block-book-a-coach__background" />
      <div className="block-book-a-coach__content d-flex __column __align-center">
        <h2 className="h2 mb-4">{t("Ready to strengthen your careers promise?")}</h2>
        <div className="subtitle-1 fw-semibold mb-5">
          {t("Book session with a coach today and be one step closer to securing an offer")}
        </div>
        <BaseButton className="block-book-a-coach__btn body-1 fw-bold pl-4 pr-3" to={"/coaches"} large borderless>
          {t("Find a Coach")}
          <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
        </BaseButton>
      </div>
    </div>
  );
}
